import type { SVGProps } from "react";

export const MFASmsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#757575"
      d="M9,16.2546376 L12.616264,13 L16,13 C16.5522847,13 17,12.5522847 17,12 L17,2 C17,1.44771525 16.5522847,1 16,1 L2,1 C1.44771525,1 1,1.44771525 1,2 L1,12 C1,12.5522847 1.44771525,13 2,13 L9,13 L9,16.2546376 Z M2,-1.31006317e-14 L16,-1.31006317e-14 C17.1045695,-1.53210777e-14 18,0.8954305 18,2 L18,12 C18,13.1045695 17.1045695,14 16,14 L13,14 L8.83448237,17.7489659 C8.62922736,17.9336954 8.31308244,17.9170562 8.12835293,17.7118012 C8.04572181,17.6199888 8,17.5008397 8,17.3773188 L8,14 L2,14 C0.8954305,14 -7.54951657e-15,13.1045695 -1.15463195e-14,12 L-1.24344979e-14,2 C-1.31006317e-14,0.8954305 0.8954305,-1.39888101e-14 2,-1.31006317e-14 Z M3.5,4 C3.22385763,4 3,3.77614237 3,3.5 C3,3.22385763 3.22385763,3 3.5,3 L14.5,3 C14.7761424,3 15,3.22385763 15,3.5 C15,3.77614237 14.7761424,4 14.5,4 L3.5,4 Z M3.5,7 C3.22385763,7 3,6.77614237 3,6.5 C3,6.22385763 3.22385763,6 3.5,6 L14.5,6 C14.7761424,6 15,6.22385763 15,6.5 C15,6.77614237 14.7761424,7 14.5,7 L3.5,7 Z M3.5,10 C3.22385763,10 3,9.77614237 3,9.5 C3,9.22385763 3.22385763,9 3.5,9 L8.5,9 C8.77614237,9 9,9.22385763 9,9.5 C9,9.77614237 8.77614237,10 8.5,10 L3.5,10 Z"
    />
  </svg>
);
